/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // CarouselButton — customized built-in extending <button>

  console.log("custom");

  const CarouselButton = class extends HTMLElement {
    connectedCallback() {
      this._handleClick = () => this._onClick();
      this._handleScroll = () => this._updateVisibility();

      this.addEventListener('click', this._handleClick);
      console.log("custom-button connected");
      requestAnimationFrame(() => {
        const track = this._track();
        if (track) track.addEventListener('scroll', this._handleScroll, { passive: true });
        this._updateVisibility();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._handleClick);
      const track = this._track();
      if (track) track.removeEventListener('scroll', this._handleScroll);
    }

    _track() {
      return this.parentElement;
    }

    _updateVisibility() {
      const track = this._track();
      if (!track) return;

      const isPrev = this.dataset.direction === 'prev';
      const canSlide = isPrev
        ? track.scrollLeft > 1
        : track.scrollLeft < track.scrollWidth - track.clientWidth - 1;

      this.style.display = canSlide ? '' : 'none';
    }

    _onClick() {
      const track = this._track();
      if (!track) return;

      const isPrev = this.dataset.direction === 'prev';
      const slides = Array.from(track.children).filter(el => !el.matches('button'));
      if (!slides.length) return;

      const currentIndex = slides.reduce((closest, slide, i) => {
        const delta = Math.abs(slide.offsetLeft - track.scrollLeft);
        const closestDelta = Math.abs(slides[closest].offsetLeft - track.scrollLeft);
        return delta < closestDelta ? i : closest;
      }, 0);

      const targetIndex = isPrev
        ? Math.max(0, currentIndex - 1)
        : Math.min(slides.length - 1, currentIndex + 1);

      track.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: 'smooth' });
    }
  }


  if (!window.customElements.get("carousel-button")) {
    window.customElements.define("carousel-button", CarouselButton);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
